<template>
 <header class="text-center text-gray-200">


<router-link to="/">
          <h1 class="center text-4xl font-valorant block sm:hidden"><span class="text-red-500">vALORaNT</span>ACCOUNTS</h1>
   <h1 class="center text-4xl font-valorant hidden sm:block  md:text-5xl"><span class="text-red-500">vALORaNT</span>ACCOUNTS.NET</h1>     
</router-link>

    <!-- Navigation -->

<ul class="flex justify-center w-1/2 m-auto font-valorant">
  <li class="flex-1 mr-2">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-8 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-8 border-white rounded hover:bg-white text-red-500" to="/buy">Buy Accounts</router-link>
  </li>
  <li class="flex-1 mr-2">
    <router-link active-class="text-center text-white block border border-white rounded py-2 px-6 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-6 border-white rounded hover:bg-white text-red-500" to="/boost">Boost Accounts</router-link>
  </li>
</ul>

<ul class="flex justify-center w-1/2 m-auto font-valorant mt-2">
  <li class="flex-1 mr-2">
    <router-link active-class="text-center text-red-500 block border border-white rounded py-2 px-4 bg-white hover:bg-blue-700 " class="text-center text-white block border py-2 px-4 border-white rounded hover:bg-white hover:text-red-500" to="/myaccount">Your <span class="text-red-500">v</span>A.net Account</router-link>
  </li>
</ul>

 </header>
</template>

<script>


export default {
  name: 'TitleBar',
  data () {
    return {

    }
  },
 beforeMount(){
 },    
}
</script>


// WEBPACK FOOTER //
// src/components/TitleBar.vue